import { render, staticRenderFns } from "./ModalProjectGroupRemove.vue?vue&type=template&id=25580db5&lang=pug"
import script from "./ModalProjectGroupRemove.vue?vue&type=script&lang=js"
export * from "./ModalProjectGroupRemove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports